import { render, staticRenderFns } from "./WhatsappChannelConnectionViewOnboarding.vue?vue&type=template&id=412c1a64&scoped=true"
import script from "./WhatsappChannelConnectionViewOnboarding.vue?vue&type=script&lang=js"
export * from "./WhatsappChannelConnectionViewOnboarding.vue?vue&type=script&lang=js"
import style0 from "./WhatsappChannelConnectionViewOnboarding.vue?vue&type=style&index=0&id=412c1a64&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c1a64",
  null
  
)

export default component.exports